<script>
/* eslint-disable no-undef */
import { cloneDeep, isEqual } from 'lodash-es'

export default {
    name: 'ZhCalendar',

    props: {
        startDate: {
            type: String,
            default: '2021-01-01'
            // required: true
        },
        endDate: {
            type: String,
            default: '2022-01-01'
            // required: true
        },
        searchEndpoint: {
            type: String,
            required: true
        },
        occasionsEndpoint: {
            type: String,
            default: 'dummy'
            // required: true
        },
        filterOptions: {
            type: Object,
            required: true
        },
        initFilterState: {
            type: Object,
            required: false,
            default: () => null
        },
        initFilterStates: {
            type: Array,
            required: false,
            default: () => []
        },
        occasionsInit: {
            type: Array,
            required: true
        },
        disableDailyView: {
            type: Boolean,
            default: false
        },
        mode: {
            type: String,
            required: false,
            default: () => 'web'
        },
    },

    data() {
        return {
            zenHeaderHeight: 0,
            mobileShowFiltersHeight: 0,
            viewSelectorHeight: 0,
            filtersContainerHeight: 0,
            hideMobileShowFilters: true,

            momentLocale: moment.locale(),
            viewComponents: this.getViewComponents(),
            currentView: 'list',
            loading: false,

            today: null,
            navDay: null,
            navWeekStart: null,
            navMonthStart: null,
            navDateRange: {
                start: this.startDate.slice(0, 10),
                end: this.endDate.slice(0, 10)
            },

            occasionsLoadedRange: {
                start: this.startDate.slice(0, 10),
                end: this.endDate.slice(0, 10)
                // start: null,
                // end: null
            },

            occasions: this.occasionsInit,

            calendar: null,

            filterState: null,
            previousFilterState: null
        }
    },

    created() {
        window.addEventListener('scroll', this.handleScroll)

        if ( this.disableDailyView ) {
            this.viewComponents.shift()
        }

        const _today = moment()
        this.today = _today
        this.navDay = cloneDeep(_today)
        this.navWeekStart = cloneDeep(_today).startOf('week')
        this.navMonthStart = cloneDeep(_today).startOf('month')

        let _occasionsLoadedRangeStart = cloneDeep(_today).startOf('month')
        _occasionsLoadedRangeStart.subtract(6, 'days').startOf('day')

        this.occasionsLoadedRange.start = _occasionsLoadedRangeStart

        let _occasionsLoadedRangeEnd = cloneDeep(_today).endOf('month')
        _occasionsLoadedRangeEnd.add(6, 'days').startOf('day')

        this.occasionsLoadedRange.end = _occasionsLoadedRangeEnd

        this.calendar = {
            daily: {
                getOccasionsForDay: this.getOccasionsForDay
            },
            weekly: {
                getOccasionsForWeek: this.getOccasionsForWeek
            },
            monthly: {
                getOccasionsForDay: this.getOccasionsForDay
            },
            list: {
                getOccasionsForDay: this.getOccasionsForDay
            }
        }

        console.log(this.mode)
    },

    destroyed() {
        window.removeEventListener('scroll', this.handleScroll)
    },

    mounted() {
        const filtersContainer = document.getElementById('calendar-filters-container')
        this.filtersContainerHeight = filtersContainer.clientHeight
        this.observeHeight()
    },

    methods: {
        // eslint-disable-next-line no-unused-vars
        handleScroll(_event) {
            if ( window.scrollY < this.filtersContainerHeight+this.zenHeaderHeight ) {
                this.hideMobileShowFilters = true
            } else {
                this.hideMobileShowFilters = false
            }
        },
        observeHeight() {
            const resizeObserverZenHeader = new ResizeObserver(entries => {
                this.zenHeaderHeight = entries[0].target.clientHeight
            })
            resizeObserverZenHeader.observe(document.getElementById('zen-page-header'))

            const resizeObserverMobileShowFilters = new ResizeObserver(entries => {
                this.mobileShowFiltersHeight = entries[0].target.clientHeight
            })
            resizeObserverMobileShowFilters.observe(document.getElementById('mobile-show-filters'))

            const resizeObserverViewSelector = new ResizeObserver(entries => {
                this.viewSelectorHeight =  entries[0].target.clientHeight
            })
            resizeObserverViewSelector.observe(document.getElementById('view-selector'))
        },

        isCustomDateRange() {
            return this.filterState &&
                this.filterState.date &&
                this.filterState.date.start !== null &&
                this.filterState.date.end !== null
        },

        getOccasionsForDay(day) {
            // day: 'YYYY-MM-DD'
            const found = this.occasions.find(element => element.date === day)
            if ( typeof found === 'undefined' ) {
                return []
            }
            return found.occasions
        },

        getOccasionsForWeek(weekStart) {
            // weekStart: moment
            let days = []
            for (let i = 0; i < 7; i++) {
                let _dayDate = cloneDeep(weekStart)
                _dayDate.add(i, 'd').startOf('day')
                days.push(
                    {
                        date: cloneDeep(_dayDate),
                        occasions: this.getOccasionsForDay(this.dateFormatDayISO(_dayDate))
                    }
                )
            }
            return days
        },

        changeView(component) {
            this.currentView = component
        },

        updateFilterState(payload) {
            this.filterState = payload
            if ( !this.isCustomDateRange() ) {
                this.navDateRange = {
                    start: this.startDate.slice(0, 10),
                    end: this.endDate.slice(0, 10)
                }
            }
        },

        goToDay(payload) {
            this.navDay = payload
            this.currentView = 'daily'
            this.$nextTick(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' })
            })
        },

        navigate(payload) {
            const dayChange = cloneDeep(this.navDay)
            const weekChange = cloneDeep(this.navWeekStart)
            const monthChange = cloneDeep(this.navMonthStart)

            switch (payload) {
            case 'day-before':
                dayChange.subtract(1, 'd').startOf('day')
                this.navDay = Object.assign(moment(), dayChange)
                break
            case 'day-after':
                dayChange.add(1, 'd').startOf('day')
                this.navDay = Object.assign(moment(), dayChange)
                break
            case 'week-before':
                weekChange.subtract(7, 'days').startOf('day')
                this.navWeekStart = Object.assign(moment(), weekChange)
                break
            case 'week-after':
                weekChange.add(7, 'days').startOf('day')
                this.navWeekStart = Object.assign(moment(), weekChange)
                break
            case 'month-before':
                monthChange.subtract(1, 'months').startOf('day')
                this.navMonthStart = Object.assign(moment(), monthChange)
                break
            case 'month-after':
                monthChange.add(1, 'months').startOf('day')
                this.navMonthStart = Object.assign(moment(), monthChange)
                break
            default:
                console.error('unknown case in zh-calendar navigate: ', payload)
            }

            this.fetchOccasionsWhenNeeded()
        },

        transformedFilterState() {
            return this.filterState === null ?
                null :
                {
                    categories: this.filterState.categories.map(item => item.id),
                    genres: this.filterState.genres.map(item => item.id),
                    audiences: this.filterState.audiences.map(item => item.name),
                    locations: this.filterState.locations.map(item => item.id),
                    onlineEvent: this.filterState.onlineEvent,
                    freeParticipation: this.filterState.freeParticipation,
                    accessible: this.filterState.accessible,
                }
        },

        // eslint-disable-next-line no-unused-vars
        async fetchOccasionsFor(_type, _startDate, _endDate) {

            let _occasionsLoadRangeStart
            let _occasionsLoadRangeEnd

            if ( _type === 'month' || _type === 'month-filter' ) {
                _occasionsLoadRangeStart = cloneDeep(_startDate).startOf('month')
                _occasionsLoadRangeStart.subtract(6, 'days').startOf('day')

                _occasionsLoadRangeEnd = cloneDeep(_startDate).endOf('month')
                _occasionsLoadRangeEnd.add(6, 'days').startOf('day')

            } else if ( _type === 'custom-date-range' || _type === 'custom-date-range-filter' ) {
                _occasionsLoadRangeStart = _startDate.startOf('day')
                _occasionsLoadRangeEnd = _endDate.startOf('day')

            } else {
                console.error('Unknown type in fetchOccasionsFor!')
            }

            const _startIsSame = moment(this.occasionsLoadedRange.start).isSame(_occasionsLoadRangeStart)
            const _endIsSame = moment(this.occasionsLoadedRange.end).isSame(_occasionsLoadRangeEnd)
            const _isEqual = isEqual(this.transformedFilterState(), this.previousFilterState)

            if ( _startIsSame && _endIsSame && _isEqual ) {
                return
            }

            let result = null
            this.loading = true

            try {
                result = await axios.post(
                    this.occasionsEndpoint,
                    {
                        startDate: this.dateFormatDayISO(_occasionsLoadRangeStart),
                        endDate: this.dateFormatDayISO(_occasionsLoadRangeEnd),
                        filterState: this.transformedFilterState(),
                        locale: window.currentLocale
                    }
                )
                if ( result ) {
                    this.previousFilterState = cloneDeep(this.transformedFilterState())

                    this.occasions = result.data
                    this.occasionsLoadedRange.start = _occasionsLoadRangeStart
                    this.occasionsLoadedRange.end = _occasionsLoadRangeEnd

                    if ( _type !== 'month-filter' ) {
                        let _monthStart = cloneDeep(_startDate).startOf('month')
                        let _weekStart = cloneDeep(_startDate).startOf('week')
                        let _dayStart = cloneDeep(_startDate)

                        this.navMonthStart = _monthStart
                        this.navWeekStart = _weekStart
                        this.navDay = _dayStart
                    }

                    if ( _type === 'custom-date-range-filter' ) {
                        this.navDateRange = {
                            start: this.dateFormatDayISO(_occasionsLoadRangeStart),
                            end: this.dateFormatDayISO(_occasionsLoadRangeEnd)
                        }
                    }
                }
            } catch (error) {
                console.error(error)
            } finally {
                this.loading = false
            }
        },

        fetchOccasionsWhenNeeded(opt) {
            if (typeof opt === 'undefined') { opt = { force: false } }

            if ( this.isCustomDateRange() ) {
                if ( opt.force ) {
                    this.fetchOccasionsFor('custom-date-range-filter', moment(this.filterState.date.start), moment(this.filterState.date.end))
                    return
                } else {
                    this.fetchOccasionsFor('custom-date-range', moment(this.filterState.date.start), moment(this.filterState.date.end))
                    return
                }
            }

            if ( opt.force ) {
                this.fetchOccasionsFor('month-filter', this.navMonthStart)
                return
            }

            const loadedRangeStart = this.occasionsLoadedRange.start
            const loadedRangeEnd = this.occasionsLoadedRange.end

            const trimmedRangeStart = moment(cloneDeep(this.occasionsLoadedRange.start))
            trimmedRangeStart.add(6, 'days').startOf('day')

            if ( !this.navMonthStart.isSame(trimmedRangeStart) ) {
                this.fetchOccasionsFor('month', this.navMonthStart)
                return
            }

            const navWeekEnd = cloneDeep(this.navWeekStart)
            navWeekEnd.endOf('week')

            if ( !(
                this.navWeekStart.isSameOrAfter(loadedRangeStart) &&
                navWeekEnd.isSameOrBefore(loadedRangeEnd)
            )) {
                this.fetchOccasionsFor('month', this.navWeekStart)
                return
            }

            if ( !this.navDay.isBetween(loadedRangeStart, loadedRangeEnd, 'day', '[]') ) {
                this.fetchOccasionsFor('month', this.navDay)
                return
            }
        },

        doFilter() {
            this.fetchOccasionsWhenNeeded({ force: true })
        },

        scrollTop() {
            this.$scrollTo(document.body)
        },

        getViewComponents()
        {
            if (this.mode === 'kioszk') {
                return [
                    {
                        component: 'list',
                        title: this.__('List')
                    }
                ]
            }

            return [
                {
                    component: 'daily',
                    title: this.__('Daily'),
                },
                {
                    component: 'weekly',
                    title: this.__('Weekly')
                },
                {
                    component: 'monthly',
                    title: this.__('Monthly')
                },
                {
                    component: 'list',
                    title: this.__('List')
                }
            ]
        }
    }
}
</script>

<template>
    <div class="zh-calendar pb-5">
        <calendar-filters
            :search-endpoint="searchEndpoint"
            :filter-options="filterOptions"
            :init-filter-state="initFilterState"
            :init-filter-states="initFilterStates"
            :mode="mode"
            @update-filter-state="updateFilterState"
            @do-filter="doFilter"
        />
        <div
            :class="{ 'd-none': hideMobileShowFilters }"
            :style="{
                position: 'sticky',
                top: zenHeaderHeight+'px',
                zIndex: 41
            }"
        >
            <div
                id="mobile-show-filters"
                class="d-block d-sm-none"
            >
                <div class="p-3">
                    <div class="d-flex align-items-end justify-content-between">
                        <div>
                            <div class="text-uppercase page-title">
                                {{ __('Calendar') }}
                            </div>
                        </div>
                        <div style="padding-bottom: 6px;">
                            <a
                                href="#"
                                class="btn btn-outline-primary btn-white"
                                @click.prevent="scrollTop()"
                            >
                                {{ __('Filters / Search') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <calendar-view-selector
            :style="{
                position: 'sticky',
                top: zenHeaderHeight+mobileShowFiltersHeight+'px',
                backgroundColor: 'white',
                zIndex: 41
            }"
            v-bind="{ viewComponents, currentView, hideShowFilters: hideMobileShowFilters }"
            @change-view="changeView"
        />
        <keep-alive>
            <component
                :is="currentView"
                v-bind="{
                    zenHeaderHeight: zenHeaderHeight,
                    mobileShowFiltersHeight: mobileShowFiltersHeight,
                    viewSelectorHeight: viewSelectorHeight,
                    dataSet: {
                        occasions,
                        loading,
                        today,
                        navDay,
                        navWeekStart,
                        navMonthStart,
                        navDateRange
                    },
                    calendar: calendar[currentView]
                }"
                :mode="mode"
                @navigate="navigate"
                @go-to-day="goToDay"
            />
        </keep-alive>
    </div>
</template>

<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";

#mobile-show-filters {
    background-color: $zh-blue;
    color: white;
}

.page-title {
    font-size: 19px;
    letter-spacing: 2.5px;
}

.btn.btn-white {
    font-size: 12px;
    font-weight: normal;
    color: white !important;
    border-color: white !important;
}
</style>
